import script from "./AnalyticsGeneral.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsGeneral.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsGeneral.vue?vue&type=style&index=0&id=81cbc284&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81cbc284"]])

export default __exports__